import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Container, Row, Col } from 'react-bootstrap';
import PageContainer from '../PageContainer';

const Docs = ({ content, raw }) => {
  /* eslint-disable react/no-danger */
  const document = <div className="docs" dangerouslySetInnerHTML={{ __html: content }} />;

  if (raw) {
    return document;
  }

  return (
    <PageContainer>
      <div className="content-container pt-4">
        <Container>
          <Row>
            <Col>{document}</Col>
          </Row>
        </Container>
      </div>
    </PageContainer>
  );
};

Docs.propTypes = {
  content: PropTypes.string,
  raw: PropTypes.bool,
};

export default Docs;
